import React, { useState, useEffect, useRef } from 'react';
import { Grid, Container, Box } from '@mui/material';
import axios from 'axios';
// import CountUp from 'react-countup';
import { styled } from '@mui/material/styles';

import SERVER_API_URL from '../../../config';
import AppSummary from './AppSummary';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'repeating-linear-gradient( #34383a, #4f5253, #34383a,#34383a, #34383a, #34383a)'
      : 'repeating-linear-gradient(#f0f0f0,#c0c4c5,#f0f0f0,#f0f0f0, #f0f0f0, #f0f0f0)',
  // backgroundColor: 'transparent',
  paddingTop: 10,
  marginBottom: 50,
  paddingBottom: 10,
  marginTop: 0,
}));

export default function AggregateData() {
  const [aggregateData, setAggregateData] = useState();
  // const [categoryData, setCategoryData] = useState();
  // const [isVisible, setIsVisible] = useState(false);
  const aggregateDataRef = useRef(null);

  const getAggregateData = async () => {
    try {
      const response = await axios.get(`${SERVER_API_URL}/landing/getAggregateData`);
      if (response.status === 200) {
        // console.log(response.data)
        setAggregateData(response.data);
      }
    } catch (e) {
      // console.log(e);
    }
  };

  // const getCategoryData = async () => {
  //   try {
  //     const response = await axios.get(`${SERVER_API_URL}/landing/getCategoryData`);
  //     if (response.status === 200) {
  //       // console.log(response.data)
  //       setCategoryData(response.data);
  //     }
  //   } catch (e) {
  //     // console.log(e);
  //   }
  // };

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // setIsVisible(true);
      }
    });
  };

  useEffect(() => {
    getAggregateData();
    // getCategoryData();

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    const currentRef = aggregateDataRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [aggregateDataRef]);

  return (
    <StyledBox>
      <Container ref={aggregateDataRef} maxWidth="xl" sx={{mt: -12, bgcolor: 'transparent', borderRadius: 5 }}>
        <Grid container spacing={3}> 
          <Grid item xs={12} lg={4}>
            <AppSummary
              title="ጠቅላላ ወረዳዎች"
              description="የሰሜን ሸዋ ሀገረ ስብከት በአማራ ክልል በሰሜን ሸዋ ዞን የሚገኝ የኢትዮጵያ ኦርቶዶክስ ቤተክርስቲያን አህጉረ ስብከት ነው። ብዙ እውቅ የሆኑ ገዳማት እና አድባራት ያሉት ነው። የዚህ ድረ-ገጽ ዋና አላማው በሰሜን ሸዋ ሀገረ ስብከት የሚገኙ አውራጃዎችን ፣ አጥቢያዎችን ፣ ካህናትን እና ምዕመናንን መረጃ ለማስተዳደር እና መከታተል ነው።"
              total={aggregateData && aggregateData.districtLength}
              icon={'fa-solid:map-marked-alt'}
              color="success"
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <AppSummary
              title="ጠቅላላ አብያተ ክርስቲያናት"
              description="የሰሜን ሸዋ ሀገረ ስብከት በአማራ ክልል በሰሜን ሸዋ ዞን የሚገኝ የኢትዮጵያ ኦርቶዶክስ ቤተክርስቲያን አህጉረ ስብከት ነው። ብዙ እውቅ የሆኑ ገዳማት እና አድባራት ያሉት ነው። የዚህ ድረ-ገጽ ዋና አላማው በሰሜን ሸዋ ሀገረ ስብከት የሚገኙ አውራጃዎችን ፣ አጥቢያዎችን ፣ ካህናትን እና ምዕመናንን መረጃ ለማስተዳደር እና መከታተል ነው።"
              total={aggregateData && aggregateData.churchLength}
              icon={'noto:church'}
              color="warning"
            />
          </Grid>{' '}
          <Grid item xs={12} lg={4}>
            <AppSummary
              title="ተከታይ"
              description="የሰሜን ሸዋ ሀገረ ስብከት በአማራ ክልል በሰሜን ሸዋ ዞን የሚገኝ የኢትዮጵያ ኦርቶዶክስ ቤተክርስቲያን አህጉረ ስብከት ነው። ብዙ እውቅ የሆኑ ገዳማት እና አድባራት ያሉት ነው። የዚህ ድረ-ገጽ ዋና አላማው በሰሜን ሸዋ ሀገረ ስብከት የሚገኙ አውራጃዎችን ፣ አጥቢያዎችን ፣ ካህናትን እና ምዕመናንን መረጃ ለማስተዳደር እና መከታተል ነው።"
              total={aggregateData && aggregateData.usersLength}
              color="error"
              icon={'fluent:people-team-16-filled'}
            />
          </Grid>{' '}
          {/* {isVisible &&
            categoryData &&
            categoryData.map((oneData) => (
              <Grid
                key={oneData.name}
                item
                xs={6}
                sm={4}
                md={3}
                lg={12 / categoryData.length}
                sx={{
                  transition: 'transform 0.5s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                  border: '1px solid red',
                  m:1,
                  ml: 4
                }}
              >
                <Typography variant="h4" sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CountUp end={oneData.length} duration={3} separator="," />
                </Typography>
                <Typography variant="h6" sx={{ display: 'flex', justifyContent: 'center', color: 'darkgray', ml: 2 }}>
                  {oneData.name}
                </Typography>
              </Grid>
            ))} */}
        </Grid>
      </Container>
    </StyledBox>
  );
}
